<ng-container>
  <ion-grid class="ion-no-padding">
    <ion-row class="ion-no-padding">
      <ion-col>
        <ion-item lines="none" color="transparent">
          @if (showAdminMenu) {
            <ion-menu-toggle slot="start">
              <ion-menu-button color="primary"></ion-menu-button>
            </ion-menu-toggle>
          }

          @if (showGoBack) {
            <ion-button
              class="ion-no-margin disable-default-style"
              size="small"
              [color]="color === 'dark' ? 'light' : 'dark'"
              (click)="navigationService.goBack()"
              slot="start">
              <ion-icon size="large" name="arrow-back-outline"></ion-icon>
            </ion-button>
          }

          @if (showCustomGoBack) {
            <ion-button
              class="ion-no-margin disable-default-style"
              size="small"
              [color]="color === 'dark' ? 'light' : 'dark'"
              (click)="onCustomGoBack.emit()"
              slot="start">
              <ion-icon size="large" name="arrow-back-outline"></ion-icon>
            </ion-button>
          }

          <ion-label [color]="color" class="ion-margin-horizontal title ion-text-wrap">
            @if (size === 'large') {
              <h1 class="ion-text-capitalize title">{{ title }}</h1>
            }
            @if (size === 'small') {
              <h2 class="ion-text-capitalize title">{{ title }}</h2>
            }
            <h4>{{ subtitle }}</h4>
          </ion-label>

          @if (showGoToHome) {
            <ion-button
              class="ion-no-margin disable-default-style"
              size="small"
              [color]="color === 'dark' ? 'light' : 'dark'"
              (click)="navigationService.goToHomePage()"
              slot="end">
              <ion-icon size="large" name="close-outline"></ion-icon>
            </ion-button>
          }

          @if (showEditButton && editStatus === 'read') {
            <ion-button
              class="ion-no-margin disable-default-style"
              size="small"
              [color]="color === 'dark' ? 'light' : 'dark'"
              (click)="onClickEdit()"
              slot="end">
              <ion-icon size="large" name="create-outline"></ion-icon>
            </ion-button>
          }

          @if (showEditButton && editStatus === 'edit') {
            <ion-button
              class="ion-no-margin disable-default-style"
              size="small"
              [color]="color === 'dark' ? 'light' : 'dark'"
              (click)="onEditCompleted('cancelled')"
              slot="end">
              <ion-icon size="large" name="close-outline" color="danger"></ion-icon>
            </ion-button>
          }

          @if (showEditButton && editStatus === 'edit') {
            <ion-button
              class="disable-default-style"
              size="small"
              [color]="color === 'dark' ? 'light' : 'dark'"
              [disabled]="!isEditValid"
              (click)="onEditCompleted('submitted')"
              slot="end">
              <ion-icon size="large" name="checkmark-outline" color="success"></ion-icon>
            </ion-button>
          }

          @if (showCreateButton) {
            <ion-button
              class="ion-no-margin disable-default-style"
              size="small"
              [color]="color === 'dark' ? 'light' : 'dark'"
              [disabled]="!isCreateValid"
              (click)="onCreateCompleted('submitted')"
              slot="end">
              <ion-icon size="large" name="add-outline" color="success"></ion-icon>
            </ion-button>
          }
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</ng-container>
